const BACKGROUND_COLOR = {
  GREEN: "primary-green", // changed the key name from red to green as per the new design update. In prismic the value is still red for this variant will have to change the name in prismic too.
  STONE: "secondary-stone-200", // changed the key name from blue to stone as per the new design update. In prismic the value is still stone for this variant will have to change the name in prismic too.
  LIGHTGREEN: "secondary-green-700", // changed the key name from lightblue to lightgreen as per the new design update. In prismic the value is still lightblue for this variant will have to change the name in prismic too.
  LIGHTSTONE: "secondary-stone-50", // changed the key name from lightgrey to lightstone as per the new design update. In prismic the value is still light grey for this variant will have to change the name in  prismic too.
};

export const getBackgroundColor = (backgroundColor: string | null) => {
  switch (backgroundColor) {
    case "blue":
      return BACKGROUND_COLOR.STONE;

    case "light grey":
      return BACKGROUND_COLOR.LIGHTSTONE;

    case "light blue":
      return BACKGROUND_COLOR.LIGHTGREEN;

    default:
      return BACKGROUND_COLOR.GREEN;
  }
};
